import { CONNECT_INFO } from './components/const'

export const ALL_KEY = 'ALL'

export const STATS_API_VALUE = {
    [CONNECT_INFO.GOOD.NAME]: 'good',
    [CONNECT_INFO.NONOPTIMAL.NAME]: 'suboptimal',
    [CONNECT_INFO.POOR.NAME]: 'poor',
    [CONNECT_INFO.LOSS.NAME]: 'disconnected'
}

export const ROLE_OPTION_KEYS = [
    { value: 'all', label: 'title.all' },
    { value: 'owner', label: 'modalDetail.roleUser.owner' },
    { value: 'host', label: 'modalDetail.roleUser.host' },
    { value: 'coHost', label: 'modalDetail.roleUser.coHost' },
    { value: 'participant', label: 'modalDetail.roleUser.participant' },
    { value: 'guest', label: 'modalDetail.roleUser.guest' }
]

export const TIME_INTERVAL_OPTIONS = [
    { value: 1000, label: '1s' },
    { value: 2500, label: '2.5s' },
    { value: 5000, label: '5s' },
    { value: 10000, label: '10s' },
    { value: 30000, label: '30s' }
]

export const MONITOR_DETAIL_FILTER_KEYS = [
    CONNECT_INFO.GOOD.NAME,
    CONNECT_INFO.POOR.NAME,
    CONNECT_INFO.NONOPTIMAL.NAME,
    CONNECT_INFO.LOSS.NAME
]

export const ROOM_STATUS_OPTIONS = [
    { value: 'progress', label: 'Đang diễn ra' },
    { value: 'end', label: 'Đã kết thúc' }
]

export const TABLE_HEAD_MONITOR_ROOM = [
    { id: 'id', numeric: false, disablePadding: false, label: '#' },
    { id: 'roomId', numeric: false, disablePadding: false, label: 'common:table.roomId', width: 150 },
    { id: 'roomName', numeric: false, disablePadding: false, label: 'common:table.roomName', width: 150 },
    { id: 'userHostId', numeric: false, disablePadding: false, label: 'common:table.roomOwner', width: 100 },
    { id: 'tsStartedTime', numeric: false, disablePadding: false, label: 'common:table.startedTime', width: 150, type: 'time', isUnix: true, format: 'DD/MM/YYYY HH:mm:ss' },
    { id: 'tsEndedTime', numeric: false, disablePadding: false, label: 'common:table.endedTime', width: 150, type: 'time', isUnix: true, format: 'DD/MM/YYYY HH:mm:ss' },
    { id: 'participantCount', numeric: false, disablePadding: false, label: 'monitor:table.totalParticipant', width: 100 },
    { id: 'actions', numeric: false, disablePadding: false, label: 'common:table.actions' }
]

export const TABLE_HEAD_MONITOR_DETAIL_ROOM = [
    { id: 'id', numeric: false, disablePadding: false, label: '#' },
    { id: 'username', numeric: false, disablePadding: false, label: 'common:table.username', width: 150 },
    { id: 'role', numeric: false, disablePadding: false, label: 'common:table.roomRole', width: 150 },
    { id: 'duration_seconds', numeric: false, disablePadding: false, label: 'common:table.duration', width: 100 },
    { id: 'upload_bitrate_bps', numeric: false, disablePadding: false, label: 'common:table.uploadBps', width: 150 },
    { id: 'download_bitrate_bps', numeric: false, disablePadding: false, label: 'common:table.downloadBps', width: 150 },
    { id: 'rtt_ms', numeric: false, disablePadding: false, label: 'monitor:table.rtt', width: 100 },
    { id: 'packet_loss_total', numeric: false, disablePadding: false, label: 'monitor:table.packetLoss', width: 100 },
    { id: 'actions', numeric: false, disablePadding: false, label: 'common:table.actions' }
]
